// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-SelectAllStudies-SelectAllStudies-module__SelectAllStudies";
var _2 = "webpack-pages-StudyList-SelectAllStudies-SelectAllStudies-module__checkbox";
export { _1 as "SelectAllStudies", _2 as "checkbox" }
